module.exports = __webpack_public_path__ + "img/investment-plan-img.9f9d4e53.png";